const SanteFamilleCodeEnum = {
  HOSPITALISATION: 'Hospitalisation',
  DENTAIRE: 'Dentaire',
  OPTIQUE: 'Optique',
  MEDECINE: 'Soins courants',
  PREVENTION: 'Prévention'
}
Object.freeze(SanteFamilleCodeEnum)

export { SanteFamilleCodeEnum }
